import React from "react";
import classNames from "classnames";
import { DropdownArrowDownIcon, DropdownArrowUpIcon } from "@netapp/bxp-style/react-icons/Navigation";
import { CheckComponent, Text } from "../../";
import ActionMenu from "../ActionMenu/ActionMenu";
import { Checkbox } from "../Forms";
import tableStyles from "./Table.module.scss";
import styles from "./Table.module.scss";
import { SELECTING_COL_WIDTH } from "./TableConstants";

const selectingColumn = (innerTable, renderType, widthDelta) => {
    return {
        id: "rowSelector",
        width: SELECTING_COL_WIDTH + widthDelta,
        fixedWidth: true,
        header: "",
        accessor: "",
        cellClass: renderType === "tree" ? tableStyles['tree-selection-cell'] : tableStyles['selection-cell'],
        Renderer: ({ isRowSelected, selectRow, isMultiSelect, disabled }) => {
            return <>
                {isMultiSelect && <Checkbox isDisabled={disabled} checked={isRowSelected || false} name="row" className={styles['cell-checkbox']} onChange={() => {
                    selectRow(!isRowSelected)
                }} />}
                {!isMultiSelect && <button onClick={disabled ? undefined : () => {
                    selectRow(true)
                }}><CheckComponent isDisabled={disabled} isHoverable={!disabled} isSelected={isRowSelected || false} className={styles['cell-checkbox']} /></button>}
            </>
        },
        HeaderRenderer: ({ column, width, selectAllRows, selectionState, headerCellClassName, stickLastColumn, stickColumn, lastColumnStickyStyleRef, stickyColumnStyleRef }) => {
            const {
                filteredRowCount,
                count: selectedCount,
                isSelectAllPagesEnabled = true,
                isSelectCurrentPageEnabled = true,
            } = selectionState;

            const className = classNames(column.headerClass, styles['header-cell'], headerCellClassName, {
                [lastColumnStickyStyleRef.current.dataset.styleid]: stickLastColumn,
                [stickyColumnStyleRef.current.dataset.styleid]: stickColumn,
                [styles['inner-table-column']]: innerTable
            });

            const style = {
                flex: column.fixedWidth ? `0 0 ${width}px` : `1 0 ${width}px`
            };

            const handleSelectAllPagesClick = () => {
                selectAllRows(true)
            }

            const handleSelectThisPageClick = () => {
                selectAllRows(true, undefined, true);
            }

            const handleClearAllClick = () => {
                selectAllRows(false, true);
            }

            const MenuOptionLabel = {
                "select_this_page": <Text children="Select this page" />,
                "clear_All": <Text children="Clear all" color={!selectedCount && "text-disabled"} />,
                "select_all_pages": <Text children="Select all pages" color={selectedCount && selectedCount === filteredRowCount && "text-button-primary"} />,
            }

            return <div className={className} style={style}>
                {selectAllRows && <>
                    <ActionMenu
                        Trigger={({ isActive, onClick }) => {
                            return <span onClick={onClick}>
                                <Checkbox
                                    className={styles['cell-checkbox']}
                                    checked={selectedCount && selectedCount === filteredRowCount}
                                    isPartial={selectedCount && selectedCount !== filteredRowCount}
                                    children={isActive ? <DropdownArrowUpIcon /> : <DropdownArrowDownIcon />}
                                />
                            </span>
                        }}>
                        {isSelectCurrentPageEnabled && <ActionMenu.Button
                            onClick={handleSelectThisPageClick}
                            children={MenuOptionLabel["select_this_page"]}
                        />}
                        {isSelectAllPagesEnabled && <ActionMenu.Button
                            onClick={handleSelectAllPagesClick}
                            children={MenuOptionLabel["select_all_pages"]}
                        />}
                        <ActionMenu.Button
                            isDisabled={!selectedCount}
                            onClick={handleClearAllClick}
                            children={MenuOptionLabel["clear_All"]}
                        />
                    </ActionMenu></>
                }
            </div>
        }
    }
};

export default selectingColumn;
